import { useCallback } from 'react';

import { useGTM, useAuthMe } from 'shared/hooks';

import type { ErrorPageType } from '../types';

const getErrorPageBase = (statusCode: ErrorPageType) => ({
  virtualURL: globalThis.window?.location.href ?? '',
  eventCategory: 'error_page',
  eventLabel: statusCode,
  eventDescription: null
});

export const useErrorPageTracking = () => {
  const { pushEvent, buildAuthData } = useGTM();
  const { data: authData } = useAuthMe();

  /** Fired when an error page is displayed to the user */
  const trackErrorPageSeen = useCallback(
    (statusCode: ErrorPageType) => {
      pushEvent('error_page', {
        ...getErrorPageBase(statusCode),
        ...buildAuthData(authData)
      });
    },
    [authData, pushEvent, buildAuthData]
  );

  return { trackErrorPageSeen };
};
